import { Controller } from "@hotwired/stimulus";
import ahoy from "ahoy.js";

export default class extends Controller {
  static values = { externalLinkId: Number }

  openAndComplete() {
    const id = this.externalLinkIdValue;
    try {
      ahoy.track("actions.taken", {
        controller: "curations",
        action: "show_external_link_page",
        external_link_id: String(id),
        source: "open_in_new_tab", 
      });
    } catch (error) {
      console.error("Failed to track external link click:", error);
    }
  }
}
